<div class="order-qty-input">
	@if (visibleLabel()) {
		<div
			class="complex"
			[class.no-pcs]="!(visibleQtySelect() && activeQtyType()?.type !== qtyTypeEnum.QTY)"
		>
			<div class="complex-qty-input">
				@if (visibleQtySelect()) {
					<div
						class="qty-select"
						[tuiDropdown]="qtyTypesList"
						[(tuiDropdownOpen)]="isOpenQtyTypes"
					>
						<p class="qty-title">{{ activeQtyType()?.title | translate }}</p>
						<app-image
							class="chevron"
							[class.open]="isOpenQtyTypes()"
							imageSrc="/images/icons/chevron-down.svg"
							imageAlt="chevron"
						/>
					</div>

					<span class="qty-value">
						{{ availableQty() | quantity }}
						{{ 'orderQtyInput.available' | translate }}
					</span>
				} @else {
					<label class="qty-label">{{ 'orderQtyInput.qty' | translate }}</label>
				}
			</div>

			<div class="simple-qty-input">
				<tui-textfield
					tuiTextfieldSize="s"
					[tuiNumberFormat]="{ decimalSeparator: ',', thousandSeparator: ' ' }"
				>
					<input
						size="s"
						tuiInputNumber
						[step]="step()"
						[min]="0"
						placeholder="0"
						inputNumberSigns
						[formControl]="formControl()"
						[tuiNumberFormat]="{
							precision: isMaxDecimalCount() ? maxDecimalCount : infinity,
							decimalMode: 'not-zero',
							rounding: 'truncate',
							decimalSeparator: ',',
						}"
					/>
				</tui-textfield>
				@if (visibleQtySelect() && activeQtyType()?.type !== qtyTypeEnum.QTY) {
					<span class="qty-value">
						{{ qty() | quantity }}
						{{ 'orderQtyInput.pcs' | translate }}
					</span>
				}
			</div>
		</div>
	} @else {
		<div class="simple">
			<tui-textfield
				tuiTextfieldSize="s"
				[tuiNumberFormat]="{ decimalSeparator: ',', thousandSeparator: ' ' }"
			>
				<input
					size="s"
					tuiInputNumber
					[step]="step()"
					[min]="0"
					placeholder="0"
					[formControl]="formControl()"
					[tuiNumberFormat]="{
						precision: isMaxDecimalCount() ? maxDecimalCount : infinity,
						decimalMode: 'not-zero',
						rounding: 'truncate',
						decimalSeparator: ',',
					}"
				/>
			</tui-textfield>
		</div>
	}
</div>

<ng-template #qtyTypesList>
	<tui-data-list
		class="qty-types-list"
		size="s"
	>
		@for (type of qtyTypes; track type.type) {
			@let isActive = activeQtyType()?.type === type.type;
			<li
				class="qty-types-item"
				[class.selectedQty]="isActive"
				(click)="setQtyType(type)"
			>
				{{ type.title | translate }}

				@if (isActive) {
					<tui-icon
						class="icon"
						icon="@tui.check"
					/>
				}
			</li>
		}
	</tui-data-list>
</ng-template>
